import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { getCurrency } from "../../../../utils";

// Actions
import {

} from '../../../../Actions/admin';
import { getDatatypes } from '../../../../Actions/main';

// components

// styles
import './AdminPackages.css';

class AdminPackages extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.props.getDatatypes();
    }


    renderPackages() {
        if (!this.props.datatypes.packages) return null

        return this.props.datatypes.packages.map((pack, index) => {
            return (
                <div className="package" key={`package-admin-${index}`}>
                    <h3 className="title">{pack.title}</h3>
                    <p>{`Price: ${getCurrency(pack.currency)}${pack.price}`}</p>
                </div>
            )
        })
    }

    render() {
        if (!this.props.datatypes) return null;

        return (
            <div className="admin-wrapper package-selector-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Main Page Packages</div>
                    </div>
                    <div className="packages-container">
                        {this.renderPackages()}
                    </div>
                </div>
            </div>
        )
    }
}

AdminPackages.propTypes = {
    token: PropTypes.string,
    datatypes: PropTypes.object,
    getDatatypes: PropTypes.func,
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    datatypes: state.main.datatypes || {}

});

export default connect(mapStateToProps, {
    getDatatypes
})(AdminPackages);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Packages/AdminPackages.js